import { BaseMutations } from '@/store/base-mutations';
import { Repairs } from '../types';
import RepairsState from './state';

export default class RepairsMutations extends BaseMutations<RepairsState> {
}
